import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDeviceCameraVideo = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M24 5.25C24 4.9798 23.8547 4.73048 23.6195 4.59735C23.3844 4.46422 23.0958 4.46786 22.8641 4.60688L16.5 8.42536V6.25C16.5 5.2835 15.7165 4.5 14.75 4.5H1.75C0.783502 4.5 0 5.2835 0 6.25V17.25C0 18.2165 0.783502 19 1.75 19H14.75C15.7165 19 16.5 18.2165 16.5 17.25V15.0746L22.8641 18.8931C23.0958 19.0321 23.3844 19.0358 23.6195 18.9027C23.8547 18.7695 24 18.5202 24 18.25V5.25ZM16.5 13.3254L22.5 16.9254V6.57464L16.5 10.1746V13.3254ZM15 6.25C15 6.11193 14.8881 6 14.75 6H1.75C1.61193 6 1.5 6.11193 1.5 6.25V17.25C1.5 17.3881 1.61193 17.5 1.75 17.5H14.75C14.8881 17.5 15 17.3881 15 17.25V6.25Z",
		fill: "var(--colors-grey-1)"
	})
});
export default SvgDeviceCameraVideo;
